module.exports = __webpack_public_path__ + "static/img/court.8aae8a7e.png";